import {spotheroGet} from 'api';
import {ConfigResponse} from 'api/config/config.types';
import {sendSentryException} from 'utils/error-handling';

/**
 * Gets the serverside config settings for the application
 *
 * @see '/api/v1/control-panel-config/'
 */
export const getControlPanelConfig = async () => {
    try {
        const response = await spotheroGet<ConfigResponse>(
            'control-panel-config/'
        );

        return response.data.data;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};
